var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92188 1.51562H3.8125C3.87266 1.51562 3.92188 1.46641 3.92188 1.40625V1.51562H8.07812V1.40625C8.07812 1.46641 8.12734 1.51562 8.1875 1.51562H8.07812V2.5H9.0625V1.40625C9.0625 0.923633 8.67012 0.53125 8.1875 0.53125H3.8125C3.32988 0.53125 2.9375 0.923633 2.9375 1.40625V2.5H3.92188V1.51562ZM10.8125 2.5H1.1875C0.945508 2.5 0.75 2.69551 0.75 2.9375V3.375C0.75 3.43516 0.799219 3.48438 0.859375 3.48438H1.68516L2.02285 10.6348C2.04473 11.101 2.43027 11.4688 2.89648 11.4688H9.10352C9.57109 11.4688 9.95527 11.1023 9.97715 10.6348L10.3148 3.48438H11.1406C11.2008 3.48438 11.25 3.43516 11.25 3.375V2.9375C11.25 2.69551 11.0545 2.5 10.8125 2.5ZM8.99824 10.4844H3.00176L2.6709 3.48438H9.3291L8.99824 10.4844Z",
    fill: "#446EB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUser);
export default __webpack_public_path__ + "static/media/delete-user.069d1774ac62c93895e4ddffc1abf451.svg";
export { ForwardRef as ReactComponent };